import React from 'react'
import StagesManager from '../components/StagesManager';
import HttpServices from '../utils/Http.services';
import { checkConditionGroup, chooseFontColor, getToken, pathMaker } from '../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import CAIntroduction from './CreateApplet/CAIntroduction';
import CASelectType from './CreateApplet/CASelectType';
import CAInfo from './CreateApplet/CAInfo';
// import CHUsername from './CreateApplet/CHUsername';
import CASuccess from './CreateApplet/CASuccess';
import CAMessengerType from './CreateApplet/CAMessengerType';
// import CAAccess from './CreateApplet/CAAccess';
import CAFormBuilder from './CreateApplet/CAFormBuilder';
import CAStageType from './CreateApplet/CAStageType';
import CAMultiStage from './CreateApplet/CAMultiStage';
import CAInquiryType from './CreateApplet/CAInquiryType';
import PermissionsPage from './Applets/PermissionsPage';
import UserPrespective from './CreateApplet/UserPrespective';
// import CAUserPrespective from './CreateApplet/CAUserPrespective';
import store from '../stores/storeConfig';
// import CAHeader from '../components/header/CAHeader';
import Header from '../components/header/Header';
import { BookingPages, CommercePages, CommerceUserPages, FinanceAdminFrames } from '../variables/AppletPages';
import CAFrameName from './CreateApplet/CAFrameName';
import AutomationTemplateSelect from './CreateApplet/AutomationTemplateSelect';
import DiagramEditor from './Applets/database/stage/DiagramEditor';


class CreateApplet extends React.Component {
    state = {

        baseApplets: [
            {
                name: '{{lang}}ca.Database', features: ['Database'], steps: [

                    { id: 'type', to: 'name' },
                    { id: 'name', to: 'formBuilder' },
                    { id: 'formBuilder', to: 'access' },
                    { id: 'access', to: 'stageType' },
                    { id: 'stageType', to: 'template', condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'multi' } } } } },
                    { id: 'stageType', to: "userPrespective", condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'single' } } } } },

                    { id: 'template', to: 'multiStage', condition: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '==' }, target: { value: 'basic' } }, } } },
                    { id: 'template', to: 'diagramEditor', condition: { id: 'root', action: 'or', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '==' }, target: { value: 'advanced' } }, } } },
                    { id: 'template', to: "info", condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '!=' }, target: { value: 'basic' } }, 2: { id: 2, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '!=' }, target: { value: 'advanced' } } } } },


                    // { id: 'template', to: 'info' },

                    { id: 'multiStage', to: 'info' },
                    { id: 'userPrespective', to: 'info' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'collection', name: "Untitled collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/database.png'
            },
            {
                name: '{{lang}}ca.Tasking', features: ['Tasking'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'info' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Default tasks" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },
            {
                name: '{{lang}}ca.Messenger', features: ['Messenger'], steps: [

                    { id: 'type', to: 'messengerType' },
                    { id: 'messengerType', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'info' },

                ],
                frames: [{ id: "messenger", key: "messenger", pageType: 'messenger', name: "Default messenger" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/portals/chat (2).png'
            },
            {
                name: '{{lang}}ca.Rooms', features: ['Rooms'], steps: [

                    { id: 'type', to: 'name' },
                    { id: 'name', to: 'access' },
                    { id: 'access', to: 'info' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'rooms', name: "Untitled collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/portals/chat (2).png'
            },
            {
                name: '{{lang}}ca.Finance', features: ['Finance'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'info' },

                ],
                frames: Object.values(FinanceAdminFrames.pages),
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/finance.png'
            },
            {
                name: '{{lang}}ca.Commerce', features: ['Commerce'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'info' },
                    // { id: 'userPrespective', to: 'info' },

                ],
                frames: Object.values(CommercePages.pages),
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/commerce.png'
            },
            // { name: '{{lang}}ca.Commissions', features: ['Commissions'], steps: [], description: '{{lang}}This is the description of this applet type', icon: '/images/man.svg' },
            {
                name: '{{lang}}ca.Booking', features: ['Booking'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'info' },

                ], 
                frames: Object.values(BookingPages.pages),
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/booking.png'
            },

            {
                name: '{{lang}}ca.Inquiry', features: ['Inquiry'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'info' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'collection', name: "Default collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/inquiry.png'
            },
            {
                name: '{{lang}}ca.Drive', features: ['Drive'], steps: [
                    { id: 'type', to: 'name' },
                    { id: 'name', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'info' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'drive', name: "Default drive" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/drive.png'
            },
            {
                name: '{{lang}}Calendar', features: ['Calendar'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'info' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'calendar', name: "Default calendar" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },
            {
                name: '{{lang}}Email', features: ['Email'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'info' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'email', name: "Default calendar" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },
            {
                name: '{{lang}}Developers', features: ['Developer'], steps: [
                    { id: 'type', to: 'name' },
                    { id: 'name', to: 'access' },
                    { id: 'access', to: 'info' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'collection', name: "Untitled collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },

        ],



        colors: {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        },
        bgColor: "linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))",
        // pages: [
        //     { title: '{{lang}}ca.Usecases', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Utilities', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Applets', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.About us', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Academy', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Newsroom', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.developers', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Advertising', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        //     { title: '{{lang}}ca.Contact Us', icon: '', link: 'https://intro.yonnect.net/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },

        // ],
        // colors: {
        //     primaryColor: '#5856d6',
        //     secondaryColor: '#7c7aff',
        //     textColor: '#fff'
        // },
        showBackBtn: false,
        show: false,
        settings: { indicatorType: 'phone', mode: 'login', loginWithCode: false, passwordRequired: true },
        data: {},
        headerConfig: { isPortal: true, doNotshowNotification: true }
    }


    componentDidMount() {
        // this.changeStage('access')

    }


    // goToInitPage = () => {
    //     this.changeStage('init')
    // }



    setData = (data, cb, refKey) => {
        let mainKey = refKey ?? 'data'
        let newData = this.state[mainKey]

        if (!newData) {
            newData = {}
        }

        // console.log('newData', newData)
        // console.log('nData', data)
        for (const [key, value] of Object.entries(data)) {
            // console.log('key', key)
            // console.log('value', value)
            newData[key] = value
        }

        this.setState({ [mainKey]: newData }, () => {
            if (cb) { cb() }
        })
    }



    changeStage = (newStage, cb) => {
        if (this.stageManager) {
            this.stageManager.changeStage(newStage, cb)
        }
    }

    lastStage = () => {
        if (this.stageManager) {
            this.stageManager.lastStage()
        }
    }


    createApplet = (cb) => {

        let data = this.state.data

        // console.log(data)
        // return
        HttpServices.request("createApplet", data, (fetchResult, fetchError) => {

            if (fetchError) {
                cb(false, fetchError.message)
                return
            }

            if (fetchResult.info) {
                // console.log(fetchResult.info)
                // this.stageManager.nextStage()
                this.changeStage('success')
                this.setData(fetchResult.info)
            }
            let connections = fetchResult.connection

            if (!Array.isArray(connections)) {
                connections = [connections]
            }
            store.dispatch(actions.appendConnection(connections))
            // this.props.history.push('/')

        })
    }


    visitHub = () => {
        this.props.changeWindow('hub', { path: [this.state.hubInfo?.username] })
    }

    visitApplet = () => {
        let appId = this.state.data?.slug ?? this.state.data?.urlcode
        this.props.changeWindow('applet', { path: [this.state.hubInfo?.username, appId] })
    }


    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    showHeader = (prop, cb) => {
        this.setState({ show: prop }, () => {
            if (cb) {
                cb()
            }
        })
    }



    setFrameFields = (fields, index = 0, cb) => {

        let data = this.state.data
        if (Array.isArray(data.frames)) {
            data.frames[index].fields = fields
        }

        this.setState({ data }, () => {
            cb()
        })
    }



    continue = (currentStage) => {

        let currentAppletTemplate = this.state.currentAppletTemplate
        let data = this.state.data

        if (currentAppletTemplate) {

            let steps = currentAppletTemplate.steps
            let nextStep

            if (steps) {

                steps.forEach(step => {

                    if (step.id == currentStage && (!step.condition || checkConditionGroup(step.condition, { data }))) {
                        nextStep = step.to
                    }

                });


            }

            if (nextStep) {
                this.stageManager.changeStage(nextStep)
            }
        }


    }


    setCurrentAppletTemplate = (applet, cb) => {

        let hub = this.state.data?.hub
        let features = this.state.data?.features

        let data = { frames: applet.frames, hub: hub, features }
        if (applet.config) {
            Object.entries(applet.config).map(([key, value]) => {
                data[key] = value
            })
        }
        this.setState({ data }, () => {
            // this.setData(data, () => {
            this.setState({ currentAppletTemplate: applet }, () => {
                cb()
            })
            // })
        })
    }


    render() {

        let variables = {
            appletHub: this.state?.hubInfo,
            appletHubId: this.state?.hubInfo?._id ?? this.state?.hubInfo,

        }

        let colors = this.state.colors ?? {}

        if (this.props.user.info?.colorType == 'sameAsHub') {
            if (this.props.user.info?.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // console.log(this.state.data)
        return (
            <div className="w-100 d-flex flex-column CreateApplet window-content-radius h-100"  >
                <div style={{ position: 'relative', top: 0, display: this.state.show ? 'flex' : 'none' }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} language={this.props.language} isDesktop={this.props.isDesktop} backbtn={this.state.showBackBtn} width={this.props.width} colors={colors} setHeader={this.setHeader} />
                </div>
                {/* <div className=' w-100  h-100 bg-white window-content-radius'> */}
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'}>
                    <CAIntroduction stage={0} stageName={'init'} continue={() => this.stageManager.changeStage('type')} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />

                    <CAFrameName stage={1} stageName={'name'} initStage={'name'} customHeaderKey={'collectionInfo.collectionName'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} bgColor={this.state.bgColor} baseApplets={this.state.baseApplets} setCurrentAppletTemplate={this.setCurrentAppletTemplate} isCreateFrame={true} />
                    <CASelectType stage={1} stageName={'type'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} bgColor={this.state.bgColor} baseApplets={this.state.baseApplets} setCurrentAppletTemplate={this.setCurrentAppletTemplate} />
                    <CAMessengerType stage={10} stageName={'messengerType'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} setFrameFields={this.setFrameFields} />
                    <CAInquiryType stage={10} stageName={'inquiryType'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />
                    <CAFormBuilder stage={10} stageName={'formBuilder'} continue={this.continue} setFrameFields={this.setFrameFields} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} lastStage={this.lastStage} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} bgColor={this.state.bgColor} />
                    <PermissionsPage stage={10} stageName={'access'} continue={this.continue} frames={this.state.data?.frames} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} lastStage={this.lastStage} user={this.props.user} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} forApplet={true} />

                    <CAStageType stage={10} stageName={'stageType'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} colors={this.state.colors} lastStage={this.lastStage} initData={this.state.data} user={this.props.user} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />

                    <AutomationTemplateSelect stage={2} stageName="template" width={this.props.width} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} bgColor={this.state.bgColor} baseApplets={this.state.baseApplets} continue={this.continue} />

                    <CAMultiStage stage={10} stageName={'multiStage'} continue={this.continue} frames={this.state.data?.frames} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} saveTitle='Next' isCreateFrame={true} />

                    <DiagramEditor stage={10} stageName={'diagramEditor'} continue={this.continue} frames={this.state.data?.frames} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} saveTitle='Next' isCreateFrame={true} />


                    {/* <CAAccess stage={10} stageName={'access'} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} /> */}
                    <UserPrespective stage={10} stageName={'userPrespective'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} lastStage={this.lastStage} user={this.props.user} colors={this.state.colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} forApplet={true} />
                    {/* <CAUserPrespective lastStage={this.lastStage} stage={10} stageName={'userPrespective'} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} forApplet={true} /> */}

                    {/* <CHUsername stage={3} stageName={'username'} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} createApplet={this.createApplet} width={this.props.width} /> */}
                    <CAInfo stage={2} stageName={'info'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} user={this.props.user} initData={this.state.data} colors={this.state.colors} language={this.props.settings?.language} setData={this.setData} createApplet={this.createApplet} width={this.props.width} />

                    <CASuccess stage={4} stageName={'success'} continue={this.continue} variables={variables} showHeader={this.showHeader} setHeader={this.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} visitHub={this.visitHub} visitApplet={this.visitApplet} width={this.props.width} />
                </StagesManager>

                {/* </div> */}



            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateApplet);
